export enum TripPatternCheckpointGeofenceMark {
    FIRST = 1, // Primero
    LAST = 2, // Último
}